/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
// asset imports

/* eslint camelcase: ["error", {properties: "never"}]*/

/* eslint-disable camelcase */
import ai_AI_128 from '../../../assets/ccsearch/ai_AI_128.svg';
import ai_AIC_128 from '../../../assets/ccsearch/ai_AIC_128.svg';
import sp_page_filetype_128 from '../../../assets/ccsearch/sp_page_filetype_128.svg';
// import mu_cc_app_RGB from '../../../assets/ccsearch/mu_cc_app_RGB.svg';
import psfix_app_RGB from '../../../assets/ccsearch/psfix_app_RGB.svg';
import psmix_app_RGB from '../../../assets/ccsearch/psmix_app_RGB.svg';
import sketch_app_RGB from '../../../assets/ccsearch/sketch_app_RGB.svg';
import comp_app_RGB from '../../../assets/ccsearch/comp_app_RGB.svg';
import draw_app_RGB from '../../../assets/ccsearch/draw_app_RGB.svg';
import pr_clip from '../../../assets/ccsearch/pr-clip.svg';
import xd_XD_128 from '../../../assets/ccsearch/xd_XD_128.svg';
import xd_XDC_128 from '../../../assets/ccsearch/xd_XDC_128.svg';
import folder from '../../../assets/ccsearch/folder.svg';
import folder_dark from '../../../assets/ccsearch/folder_dark.svg';
import shared_folder from '../../../assets/ccsearch/shared-folder.svg';
import shared_folder_dark from '../../../assets/ccsearch/shared-folder_dark.svg';
import filetype_generic_128 from '../../../assets/ccsearch/filetype_generic_128.svg';
import filetype_generic_128_dark from '../../../assets/ccsearch/filetype_generic_128_dark.svg';
import empty_icon from '../../../assets/ccsearch/empty_icon.svg';
import link_out_icon from '../../../assets/ccsearch/link_out_icon.svg';
import default_image from '../../../assets/ccsearch/default_image.svg';
import empty_library from '../../../assets/ccsearch/empty_library.png';
import Smock_CCLibrary_24_N from '../../../assets/ccsearch/Smock_CCLibrary_24_N@2x.svg';
import Smock_UserGroup_18_N from '../../../assets/ccsearch/Smock_UserGroup_18_N@2x.svg';
import Smock_UiMillerColumnsChevronPrevious_6x10_N from '../../../assets/ccsearch/Smock_UiMillerColumnsChevronPrevious_6x10_N@1x.svg';
import search_bar_clear from '../../../assets/ccsearch/Icon_clear.svg';
import search_bar_clear_dark from '../../../assets/ccsearch/Clear_Darkest.svg';
import id_INDT_128 from '../../../assets/ccsearch/id_INDT_128.svg';
import acrobat_PDF_128 from '../../../assets/ccsearch/acrobat_PDF_128.svg';
import ps_PSD_128 from '../../../assets/ccsearch/ps_PSD_128.svg';
import ps_PSDC_128 from '../../../assets/ccsearch/ps_PSDC_128.svg';
import sp_post_filetype_128 from '../../../assets/ccsearch/sp_post_filetype_128.svg';
import sp_video_filetype_128 from '../../../assets/ccsearch/sp_video_filetype_128.svg';
import filetype_zip_128 from '../../../assets/ccsearch/filetype_zip_128.svg';
import web_icon from '../../../assets/ccsearch/web.svg';
import mobile_icon from '../../../assets/ccsearch/mobile.svg';
import desktop_icon from '../../../assets/ccsearch/desktop.svg';
import ae_AECAP_128 from '../../../assets/ccsearch/ae_AECAP_128.svg';
import ae_AEG_128 from '../../../assets/ccsearch/ae_AEG_128.svg';
import ae_AEP_128 from '../../../assets/ccsearch/ae_AEP_128.svg';
import ae_AEPX_128 from '../../../assets/ccsearch/ae_AEPX_128.svg';
import ae_AET_128 from '../../../assets/ccsearch/ae_AET_128.svg';
import ae_AETX_128 from '../../../assets/ccsearch/ae_AETX_128.svg';
import dw_DW_128 from '../../../assets/ccsearch/dw_DW_128.svg';
import dw_DWT_128 from '../../../assets/ccsearch/dw_DWT_128.svg';
import id_IDAP_128 from '../../../assets/ccsearch/id_IDAP_128.svg';
import id_IDML_128 from '../../../assets/ccsearch/id_IDML_128.svg';
import id_INDB_128 from '../../../assets/ccsearch/id_INDB_128.svg';
import id_INDD_128 from '../../../assets/ccsearch/id_INDD_128.svg';
import id_INDP_128 from '../../../assets/ccsearch/id_INDP_128.svg';
import mu_MUSE_128 from '../../../assets/ccsearch/mu_MUSE_128.svg';
import pr_PROJ_128 from '../../../assets/ccsearch/pr_PROJ_128.svg';
import real from '../../../assets/ccsearch/real.svg';
import sp_default_filetype_128 from '../../../assets/ccsearch/sp_default_filetype_128.svg';
import creativecloud_mobile_appicon from '../../../assets/ccsearch/creativecloud_mobile_appicon.svg';
import space_list_view_icon from '../../../assets/ccsearch/space_list_view.svg';
import plugins_light from '../../../assets/ccsearch/plugins_light.svg';
import plugins_dark from '../../../assets/ccsearch/plugins_dark.svg';
import learnOnTheWeb from '../../../assets/ccsearch/learnOnTheWeb.svg';
import helpx from '../../../assets/ccsearch/helpx.svg';
import image from '../../../assets/ccsearch/acrobat_Image_Generic_lightUI_128.svg';
import audio from '../../../assets/ccsearch/acrobat_Audio_Generic_lightUI_128.svg';
import video from '../../../assets/ccsearch/acrobat_Video_Generic_lightUI_128.svg';
import txt from '../../../assets/ccsearch/acrobat_Text_Generic_lightUI_128.svg';
import presentation from '../../../assets/ccsearch/acrobat_Presentation_Generic_lightUI_128.svg';
import spreadsheet from '../../../assets/ccsearch/acrobat_Spreadsheet_Generic_lightUI_128.svg';
import parcel from '../../../assets/ccsearch/acrobat_parcel_filetype_lightUI_128.svg';
import pdf from '../../../assets/ccsearch/acrobat_PDF_lightUI_128.svg';
import image_dark from '../../../assets/ccsearch/acrobat_Image_Generic_darkUI_128.svg';
import audio_dark from '../../../assets/ccsearch/acrobat_Audio_Generic_darkUI_128.svg';
import video_dark from '../../../assets/ccsearch/acrobat_Video_Generic_darkUI_128.svg';
import txt_dark from '../../../assets/ccsearch/acrobat_Text_Generic_darkUI_128.svg';
import presentation_dark from '../../../assets/ccsearch/acrobat_Presentation_Generic_darkUI_128.svg';
import spreadsheet_dark from '../../../assets/ccsearch/acrobat_Spreadsheet_Generic_darkUI_128.svg';
import parcel_dark from '../../../assets/ccsearch/acrobat_parcel_filetype_darkUI_128.svg';
import pdf_dark from '../../../assets/ccsearch/acrobat_PDF_darkUI_128.svg';
import product_information from '../../../assets/ccsearch/productInformation.svg';
import qa_gif_dark from '../../../assets/ccsearch/convert-to-gif_dark.svg';
import qa_mp4_dark from '../../../assets/ccsearch/convert-to-mp4_dark.svg';
import qa_merge_videos_dark from '../../../assets/ccsearch/merge-videos_dark.svg';
import qa_image_resize_dark from '../../../assets/ccsearch/image-resize_dark.svg';
import qa_remove_background_dark from '../../../assets/ccsearch/remove-background_dark.svg';
import qa_resize_video_dark from '../../../assets/ccsearch/resize-video_dark.svg';
import qa_trim_video_dark from '../../../assets/ccsearch/trim-video_dark.svg';
import support_community from '../../../assets/ccsearch/community.svg';
import help_center from '../../../assets/ccsearch/Help_center.svg';
import support_community_dark from '../../../assets/ccsearch/community_dark.svg';
import help_center_dark from '../../../assets/ccsearch/Help_center_dark.svg';
// import S_Folder_18_N from '../../../assets/ccsearch/S_Folder_18_N@1x.svg';
import S2_Icon_AISparkles_20_N from '../../../assets/ccsearch/S2_Icon_AISparkles_20_N.svg';

export const SEARCH_SOURCES = ['learn', 'stock', 'creativeCloud', 'lightroom'];
export const SORT_BY_CONSTANTS = {
	modificationDate: 'ModificationDate',
	size: 'Size',
	name: 'Name',
	reverse: 'Reverse',
};
// related to SortBy flow type in SearchManagerTypes.js
export const SORT_ORDER_CONSTANTS = {
	ascending: 'Ascending',
	descending: 'Descending',
};
// related to SortOrder flow type in SearchManagerTypes.js
export const SEARCH_FILTERS_CATEGORY_LABELS = {
	dateModified: 'dateModified',
	location: 'source',
	type: 'type',
};
export const SEARCH_YOUR_WORK_FILTERS = {
	dateModified: {
		label: 'dateModified',
		all: 'all',
		today: 'today',
		yesterday: 'yesterday',
		lastSevenDays: 'lastSevenDays',
		lastThirtyDays: 'lastThirtyDays',
		lastNinetyDays: 'lastNinetyDays',
		lastYear: 'lastYear',
	},
	location: {
		label: 'source',
		yourFiles: 'YourFiles',
		sharedWithYou: 'SharedWithYou',
		teamLibraries: 'TeamLibraries',
		yourLibraries: 'YourLibraries',
		spaces: 'Spaces',
		cloudDocuments: 'CloudDocuments',
		syncedFiles: 'SyncedFiles',
		mobileCreations: 'MobileCreations',
		libraries: 'Libraries',
		lightroom: 'Lightroom',
	},
	type: {
		label: 'type',
		photoshop: 'Photoshop',
		illustrator: 'Illustrator',
		xd: 'Xd',
		prototype: 'Prototype',
		designSpec: 'DesignSpec',
		images: 'Images',
		canvas: 'Canvas',
		weblink: 'Weblink',
		folder: 'Folder',
		library: 'Library',
		libraryElement: 'LibraryElement',
		space: 'Space',
		lightroom: 'Lightroom',
		express: 'Express',
	},
};
export const SEARCH_YOUR_WORK_FILTERS_TO_LOCALIZED_STRINGS_MAP = Object.freeze({
	// Dates filter strings
	dateModified: 'app.search.yourwork.filter.date.label',
	all: 'app.search.yourwork.filter.date.all',
	today: 'app.search.yourwork.filter.date.today',
	yesterday: 'app.search.yourwork.filter.date.yesterday',
	lastSevenDays: 'app.search.yourwork.filter.date.last7days',
	lastThirtyDays: 'app.search.yourwork.filter.date.last30days',
	lastNinetyDays: 'app.search.yourwork.filter.date.last90days',
	lastYear: 'app.search.yourwork.filter.date.lastyear',
	// type filter strings
	type: 'app.search.yourwork.filter.type.label',
	Photoshop: 'app.search.yourwork.filter.type.photoshop',
	Illustrator: 'app.search.yourwork.filter.type.illustrator',
	Xd: 'app.search.yourwork.filter.type.xd',
	Prototype: 'app.search.yourwork.filter.type.prototype',
	DesignSpec: 'app.search.yourwork.filter.type.designSpec',
	Images: 'app.search.yourwork.filter.type.images',
	Canvas: 'app.search.yourwork.filter.type.canvas',
	Weblink: 'app.search.yourwork.filter.type.weblink',
	Folder: 'app.search.yourwork.filter.type.folder',
	Library: 'app.search.yourwork.filter.type.library',
	LibraryElement: 'app.search.yourwork.filter.type.libraryElement',
	Space: 'app.search.yourwork.filter.type.space',
	Lightroom: 'app.search.yourwork.filter.type.lightroom',
	Express: 'app.search.yourwork.filter.type.adobeexpress',
	// source filter strings
	source: 'app.search.yourwork.filter.source.label',
	YourFiles: 'app.search.yourwork.filter.source.yourFiles',
	SharedWithYou: 'app.search.yourwork.filter.source.sharedWithYou',
	TeamLibraries: 'app.search.yourwork.filter.source.teamLibraries',
	WorkspaceLibraries: 'app.search.yourwork.filter.source.workspaceLibraries',
	YourLibraries: 'app.search.yourwork.filter.source.yourLibraries',
	Spaces: 'app.search.yourwork.filter.source.spaces',
	CloudDocuments: 'app.search.yourwork.filter.source.cloudDocuments',
	SyncedFiles: 'app.search.yourwork.filter.source.syncedFiles',
	MobileCreations: 'app.search.yourwork.filter.source.mobileCreations',
	Libraries: 'app.search.yourwork.filter.source.libraries',
	Projects: 'app.search.yourwork.projects.title',
});
export const SEARCH_FILTERS_OPTIONS_TO_LOCALIZED_STRINGS_MAP = {
	creativeCloud: 'app.search.synced_asset.title',

	/* eslint-disable-line camelcase */
	cloudDocs: 'app.search.cloud_docs.title',

	/* eslint-disable-line camelcase */
	libraries: 'app.search.libraries.title',
	lightroom: 'app.search.lightroom.title',
	mobileCreations: 'app.search.mobileCreations.title',

	/* eslint-disable-line camelcase */
	spark: 'app.search.yourwork.filter.type.adobeexpress',
	xdArtifacts: 'app.search.xd.title',

	/* eslint-disable-line camelcase */
	ccFiles: 'app.search.synced_asset.title',
	// Add in other AssetTypes from ResultItemTypes in search-types
	image: 'app.search.yourwork.filter.images',
	video: 'app.search.spark.type.video',
	document: 'app.search.assetCategory.document',
	audio: 'app.search.assetCategory.audio',
	template: 'app.search.assetCategory.template',
	prototype: 'app.search.xd.type.prototype.lower',
	designSpec: 'app.search.xd.type.designspec.lower',
	library: 'app.search.libraries.title',
	libraryElement: 'app.search.libraries_element_asset.title',
	space: 'app.search.yourwork.spaces.title',
	project: 'app.search.yourwork.projects.title',
	yourFiles: 'app.search.yourwork.filter.source.yourFiles',
	spaceElement: 'app.search.yourwork.spaces.title',
	teamLibraries: 'app.search.yourwork.filter.source.teamLibraries',
	yourLibraries: 'app.search.yourwork.filter.source.yourLibraries',
	workspaceLibraries: 'app.search.yourwork.filter.source.workspaceLibraries',
	sharedWithYou: 'app.search.yourwork.filter.source.sharedWithYou',
	// NEW STRINGS FOR NEW FILTERS
	CloudDocuments: 'app.search.cloud_docs.title',
	SyncedFiles: 'app.search.synced_asset.title',
	MobileCreations: 'app.search.mobileCreations.title',
	Libraries: 'app.search.libraries.title',
	Spark: 'app.search.yourwork.filter.type.adobeexpress',
	XDArtifacts: 'app.search.xd.title',
	Lightroom: 'app.search.lightroom.title',
	Photoshop: 'app.search.template.type.photoshop',
	Illustrator: 'app.search.template.type.illustrator',
	Xd: 'app.search.xd',
	Images: 'app.search.yourwork.filter.images',
	localFiles: 'app.search.yourwork.filter.local',
	express: 'app.search.yourwork.filter.type.adobeexpress',
};
// The values for the keys in this map MUST match the keys in the SEARCH_TABS_CONSTANTS_INDEX_MAP
// The Host will use this as well.
export const SEARCH_TABS_CONSTANTS = {
	ALL_TAB: 'all',
	HELP_TAB: 'help',
	LEARN_TAB: 'learn',
	SUPPORT_TAB: 'support',
	COMMUNITY_TAB: 'community',
	APPS_TAB: 'apps',
	STOCK_TAB: 'stock',
	STOCK_MARKETPLACE_TAB: 'stockMarketplace',
	YOUR_WORK_TAB: 'yourWork',
	FILES_TAB: 'files',
	PRODUCT_INFORMATION_TAB: 'productInformation',
};
// The reason why there's a separate mapping for indices is so that the search child component has flexibility on re-arranging the order of the tabs without requiring Host changes.
export const SEARCH_TABS_CONSTANTS_INDEX_MAP = {
	all: 0,
	help: 2,
	apps: 1,
	stock: 3,
	stockMarketplace: 3,
	yourWork: 4,
	files: 4,
};
export const SEARCH_TABS_TO_LOCALIZED_STRINGS_MAP = {
	all: 'app.search.tab.all',
	apps: 'app.search.tab.apps',
	help: 'app.search.tab.help',
	stock: 'app.search.tab.stock',
	stockMarketplace: 'app.search.tab.stockMarketplace',
	yourWork: 'app.search.tab.yourwork',
	files: 'app.search.tab.files',
	productInformation: 'app.search.tab.productInfo',
	learn: 'app.search.tab.learn',
	community: 'app.search.tab.community',
	support: 'app.search.tab.support',
};
export const SEARCH_CONFIG_STATUS = {
	CONFIG_FETCH_COMPLETE: 'config_fetch_complete',
	CONFIG_FETCH_ERROR_OR_TIME_OUT: 'config_fetch_error_or_time_out',
	CONFIG_FETCH_SUCCESS: 'config_fetch_success',
};
export const APPS_TO_CODES_MAPPING = {
	photoshop: 'PHSP',
	illustrator: 'ILST',
	indesign: 'IDSN',
	premiere: 'PPRO',
	rush: 'RUSH',
	after: 'AEFT',
	dreamweaver: 'DRWV',
	lightroom: 'LRCC',
	xd: 'SPRK',
	stock: 'FFC_stock',
	spark: 'FFC-SPRK',
	portfolio: 'FFC_portfolio',
	fonts: 'FFC_fonts',
	creativecloud: 'KCCC',
	behance: 'FFC_behance',
	fix: 'FFC_psfix',
	fresco: 'FFC_fresco',
	default: 'FFC_ccmob',
	default_offline: creativecloud_mobile_appicon,
};
export const APPS_PLATFORM = {
	web: web_icon,
	mobile: mobile_icon,
	desktop: desktop_icon,
};
export const SEARCH_PAGES = {
	ALL_RESULTS: 'ALL_RESULTS',
	ALL_TUTORIALS: 'ALL_TUTORIALS',
};
// used in Redux to change views in SearchResultsPage
export const ERROR_ROUTES = {
	400: '/error/1',
	500: '/error/2',
};
export const TEMPLATE_TYPES = {
	PS: 'image/vnd.adobe.photoshop.template',
	IN: 'application/vnd.adobe.indesign.template',
	ILLUS: 'application/illustrator.template',
};
export const CONTENT_TYPE = {
	APP_CARD: 'result',
	LEARN_MORE: 'learn-more',
	PLUGIN_CARD: 'plugin',
	FONT_CARD: 'font',
	QUICK_ACTION_CARD: 'quick-action',
	APPS_PRIMARY_BUTTON: 'apps-primary-button',
	APPS_SECONDARY_BUTTON: 'apps-secondary-button',
};
// used for APPCard Analytics
export const SEARCH_ICONS = {
	XD_ICON: xd_XD_128,
	FOLDER_ICON: folder,
	UNKNOWN_ICON: filetype_generic_128,
	UNKNOWN_ICON_DARK: filetype_generic_128_dark,
	EMPTY_RESULTS_ICON: empty_icon,
	LINK_OUT_ICON: link_out_icon,
	DEFAULT_IMAGE: default_image,
	EMPTY_LIBRARY: empty_library,
	GENERIC_LIBRARY: Smock_CCLibrary_24_N,
	COLLAB_ICON: Smock_UserGroup_18_N,
	CHEVRON: Smock_UiMillerColumnsChevronPrevious_6x10_N,
	SUPPORT: help_center,
	FORUMS: support_community,
	SUPPORT_DARK: help_center_dark,
	FORUMS_DARK: support_community_dark,
	SEARCH_BAR_CLEAR: search_bar_clear,
	SEARCH_BAR_CLEAR_DARK: search_bar_clear_dark,
	PRODUCT_INFORMATION: product_information,
};
export const SPARK = {
	POST: 'application/vnd.adobe.theo.document+dcx',
	VIDEO: 'application/vnd.adobe.ginger.project+dcx',
	PAGE: 'application/vnd.adobe.luca.document+dcx',
};
export const SPARK_TYPE_MAPPER = {
	document: 'app.search.spark.type.post',
	video: 'app.search.spark.type.video',
	'application/vnd.adobe.theo.document+dcx': 'app.search.spark.type.post',
	'application/vnd.adobe.ginger.project+dcx': 'app.search.spark.type.video',
	'application/vnd.adobe.luca.document+dcx': 'app.search.spark.type.page',
};
export const SPARK_TEXT_TYPE_MAPPER = {
	Post: 'app.search.spark.type.post',
	Video: 'app.search.spark.type.video',
	Page: 'app.search.spark.type.page',
};
export const CCEXPRESS_TYPE_MAPPER = {
	document: 'app.search.ccexpress.type.post',
	video: 'app.search.spark.type.video',
	'application/vnd.adobe.theo.document+dcx': 'app.search.ccexpress.type.post',
	'application/vnd.adobe.ginger.project+dcx': 'app.search.spark.type.video',
	'application/vnd.adobe.luca.document+dcx': 'app.search.ccexpress.type.page',
};
export const CCEXPRESS_TEXT_TYPE_MAPPER = {
	Post: 'app.search.ccexpress.type.post',
	Video: 'app.search.spark.type.video',
	Page: 'app.search.ccexpress.type.page',
};
export const XD_TYPE_MAPPER = {
	prototype: 'app.search.xd.type.prototype',
	// v1
	'application/vnd.adobe.uxdesign.prototype+dcx': 'app.search.xd.type.prototype',
	// v2
	designSpec: 'app.search.xd.type.designspec',
	// v1
	'application/vnd.adobe.uxdesign.designspec+dcx': 'app.search.xd.type.designspec', // v2
};
export const CLOUD_DOC_TYPE_MAPPER = {
	document: 'app.search.xd',
	// v1
	'application/vnd.adobe.xd.cloudproject+dcx': 'app.search.xd',
	// v2
	'document/vnd.adobe.cpsd+dcx': 'app.search.cloud_docs.title',
	'application/vnd.adobe.real+dcx': 'app.search.cloud_docs.title',
};
export const MC = {
	CLS: 'image/vnd.adobe.cls+dcx',
	MIX: 'application/vnd.adobe.photoshop-mix.composition+dcx',
	SKETCH: 'application/vnd.adobe.sketch.project+dcx',
	FIX: 'application/vnd.adobe.photoshop-fix.composition+dcx',
	LAYUP: 'application/vnd.adobe.layup.project+dcx',
	DRAW: 'application/vnd.adobe.draw.project+dcx',
	COMP: 'application/vnd.adobe.comp.project+dcx',
	CLIP: 'application/vnd.adobe.clip.project+dcx',
};
export const ASSETS = {
	SHAREDFOLDER: 'application/x-sharedcloud-mount+json',
	GIF: 'image/gif',
	INDD: 'application/x-indesign',
	XDV2: 'application/vnd.adobe.sparkler.project+dcxucf',
	XDV1: 'application/vnd.adobe.sparkler.project+dcx',
	FOLDER: 'application/x-sharedcloud-collection+json',
	PDF: 'application/pdf',
	JPEG: 'image/jpeg',
	PNG: 'image/png',
	PSD: 'image/vnd.adobe.photoshop',
	AI: 'application/illustrator',
	ZIP: 'application/zip',
	SVG: 'image/svg+xml',
	SPARKPOST: 'application/vnd.adobe.theo.document+dcx',
	SPARKVIDEO: 'application/vnd.adobe.ginger.project+dcx',
	SPARKPAGE: 'application/vnd.adobe.luca.document+dcx',
};
export const LIBRARY_MIMETYPE_MAP = {
	LIBRARY: 'application/vnd.adobe.library+dcx',
	LIBRARY_ELEMENT_COLOR: 'application/vnd.adobe.element.color+dcx',
	LIBRARY_ELEMENT_COLORTHEME: 'application/vnd.adobe.element.colortheme+dcx',
	LIBRARY_ELEMENT_GRADIENT: 'application/vnd.adobe.element.gradient+dcx',
};
export const DEFAULT_ASSET_ICONS = {
	ai: ai_AI_128,
	aic: ai_AIC_128,
	aecap: ae_AECAP_128,
	aeg: ae_AEG_128,
	aep: ae_AEP_128,
	aepx: ae_AEPX_128,
	aet: ae_AET_128,
	aetx: ae_AETX_128,
	aero: real,
	comp: comp_app_RGB,
	dw: dw_DW_128,
	dwt: dw_DWT_128,
	idap: id_IDAP_128,
	idml: id_IDML_128,
	indb: id_INDB_128,
	indd: id_INDD_128,
	indp: id_INDP_128,
	indt: id_INDT_128,
	muse: mu_MUSE_128,
	psd: ps_PSD_128,
	psdc: ps_PSDC_128,
	prproj: pr_PROJ_128,
	zip: filetype_zip_128,
	rar: filetype_zip_128,
	epub: filetype_zip_128,
	sparkdefault: sp_default_filetype_128,
	sparkpost: sp_post_filetype_128,
	sparkvideo: sp_video_filetype_128,
	sparkpage: sp_page_filetype_128,
	xd: xd_XD_128,
	xdc: xd_XDC_128,
	folder,
	folder_dark,
	sharedfolder: shared_folder,
	sharedfolder_dark: shared_folder_dark,
	generic: filetype_generic_128,
	generic_dark: filetype_generic_128_dark,
	space: space_list_view_icon,
	plugins: plugins_dark,
	plugins_darkest: plugins_dark,
	plugins_dark,
	plugins_light,
	learnOnTheWeb,
	helpx,
	csv: spreadsheet,
	csv_dark: spreadsheet_dark,
	xls: spreadsheet,
	xls_dark: spreadsheet_dark,
	xlsx: spreadsheet,
	xlsx_dark: spreadsheet_dark,
	png: image,
	png_dark: image_dark,
	jpg: image,
	jpg_dark: image_dark,
	jpeg: image,
	jpeg_dark: image_dark,
	dng: image,
	dng_dark: image_dark,
	bmp: image,
	bmp_dark: image_dark,
	gif: image,
	gif_dark: image_dark,
	svg: image,
	svg_dark: image_dark,
	raw: image,
	raw_dark: image_dark,
	eps: image,
	eps_dark: image_dark,
	heif: image,
	heif_dark: image_dark,
	heic: image,
	heic_dark: image_dark,
	video,
	video_dark,
	mov: video,
	mov_dark: video_dark,
	mp4: video,
	mp4_dark: video_dark,
	mpeg: video,
	mpeg_dark: video_dark,
	audio,
	audio_dark,
	mp3: audio,
	mp3_dark: audio_dark,
	wav: audio,
	wav_dark: audio_dark,
	pdf,
	pdf_dark,
	ppt: presentation,
	ppt_dark: presentation_dark,
	pptx: presentation,
	pptx_dark: presentation_dark,
	ppsx: presentation,
	ppsx_dark: presentation_dark,
	parcel,
	parcel_dark,
	txt,
	txt_dark,
	docx: txt,
	docx_dark: txt_dark,
	xml: txt,
	xml_dark: txt_dark,
	html: txt,
	html_dark: txt_dark,
	js: txt,
	js_dark: txt_dark,
	rtf: txt,
	rtf_dark: txt_dark,
};
export const GENERIC_ASSET_ICONS = {
	'application/x-indesign': id_INDT_128,
	'application/vnd.adobe.sparkler.project+dcxucf': xd_XD_128,
	'application/vnd.adobe.sparkler.project+dcx': xd_XD_128,
	'application/pdf': acrobat_PDF_128,
	'image/vnd.adobe.photoshop': ps_PSD_128,
	'application/vnd.adobe.theo.document+dcx': sp_post_filetype_128,
	'application/vnd.adobe.ginger.project+dcx': sp_video_filetype_128,
	'application/vnd.adobe.luca.document+dcx': sp_page_filetype_128,
	'image/svg+xml': filetype_generic_128,
	'application/illustrator': filetype_generic_128,
	'application/zip': filetype_zip_128,
	'application/x-sharedcloud-collection+json': folder,
	'application/x-sharedcloud-mount+json': shared_folder,
	'application/vnd.adobe.comp.project+dcx': comp_app_RGB,
	'application/vnd.adobe.layup.project+dcx': comp_app_RGB,
	'application/vnd.adobe.clip.project+dcx': pr_clip,
	'application/vnd.adobe.photoshop-fix.composition+dcx': psfix_app_RGB,
	'application/vnd.adobe.sketch.project+dcx': sketch_app_RGB,
	'application/vnd.adobe.draw.project+dcx': draw_app_RGB,
	'application/vnd.adobe.photoshop-mix.composition+dcx': psmix_app_RGB,
	'image/vnd.adobe.cls+dcx': psfix_app_RGB,
};
export const ASSET_RENDITION_TYPES = [
	ASSETS.GIF,
	ASSETS.INDD,
	ASSETS.PDF,
	ASSETS.JPEG,
	ASSETS.PNG,
	ASSETS.PSD,
	ASSETS.AI,
	ASSETS.SVG,
];
export const APPS_EXCLUDED = [
	'creative cloud tutorials',
	'aviary',
	'flash-player',
	'story plus',
	'coldfusion',
	'reader',
	'elements-organizer',
	'support',
	'photoshop-elements',
	'aem-forms',
];
export const GROUPED_CATEGORIES = {
	__label__adobe_stock_assets: ['stock'],
	__label__adobe_stock_templates: ['templates'],
	__label__support: ['learn'],
	__label__forums: ['adobeForum'],
	__label__tutorials: ['tutorials'],
	__label__adobe_spark_templates: ['sparkTemplates'],
	__label__apps: ['apps'],
};
export const SEARCH_SOURCES_WITH_FILTERS = [
	'apps',
	'tutorials',
	'learn',
	'helpCenter',
	'adobeForum',
	'forums',
	'stock',
	'stockAssets',
	'stockTemplates',
	'templates',
	'plugins',
	'sparkTemplates',
	'yourWork',
	'fonts',
	'productInformation',
	'quickActions',
]; // The order for this matters for the 'All' tab!

// The below search sources are subsets of the above array
export const SEARCH_SOURCES_WITH_FILTERS_FOR_PRODUCT_INFO = ['productInformation'];
export const SEARCH_SOURCES_WITH_FILTERS_FOR_HELP = ['tutorials', 'learn', 'adobeForum', 'forums', 'helpcenter'];
export const SEARCH_SOURCES_WITH_FILTERS_FOR_LEARN = ['tutorials'];
export const SEARCH_SOURCES_WITH_FILTERS_FOR_SUPPORT = ['learn', 'helpCenter'];
export const SEARCH_SOURCES_WITH_FILTERS_FOR_COMMUNITY = ['adobeForum', 'forums'];

export const SEARCH_SOURCES_WITH_FILTERS_FOR_APPS = ['apps', 'productInformation'];
export const SEARCH_SOURCES_WITH_FILTERS_FOR_STOCK = ['stock', 'templates', 'plugins', 'fonts'];
export const SEARCH_SOURCES_FOR_TOP_RESULTS = ['tutorials', 'learn', 'stock', 'templates', 'sparkTemplates']; // this is the complete list of categories for Top Results

export const SEARCH_SOURCES_FOR_TOP_RESULTS_HELP = ['tutorials', 'learn']; // these are the help categories for the Top Results component: order matters

export const SEARCH_SOURCES_FOR_TOP_RESULTS_NO_HELP = ['stock', 'templates', 'sparkTemplates']; // these are the non-help categories for the Top Results component: order matters

export const SEARCH_LEARN_INCLUDE_TUTORIALS = [
	'Tutorial - video',
	'Tutorial - graphical',
	'Tutorial - video hands-on',
	'Tutorial - graphical hands-on',
	'Tutorial - text hands-on',
	'Tutorial - text',
];
export const SEARCH_LEARN_EXCLUDE_TUTORIALS = [
	'Reference',
	'Reference - graphical',
	'Overview',
	'Article',
	'Reference - support-how-to',
	'Troubleshooting',
	'Showcase',
	'Troubleshooting - common-problems',
	'Tip',
	'Troubleshooting - issue-solution',
	'',
];
export const APP_TYPES = {
	// based off of SEARCH_SOURCES_WITH_FILTERS
	APPS: 'apps',
	PLUGINS: 'plugins',
	LIGHTROOM: 'lightroom',
	CREATIVE_CLOUD: 'ccFiles',
	MOBILE_CREATIONS: 'mobileCreations',
	CLOUD_DOCS: 'cloudDocs',
	LIBRARIES: 'libraries',
	XD_ARTIFACTS: 'xdArtifacts',
	SPARK: 'spark',
	TUTORIALS: 'tutorials',
	LEARN: 'learn',
	ADOBE_FORUM: 'adobeForum',
	TEMPLATES: 'templates',
	STOCK: 'stock',
	SPARK_TEMPLATES: 'sparkTemplates',
	LOCAL_FILES: 'localFiles',
	SPACE: 'space',
	SPACE_ELEMENT: 'spaceElement',
	CANVAS: 'canvas',
	LEARN_ON_THE_WEB: 'learnOnTheWeb',
	HELPX: 'helpx',
	FONTS: 'fonts',
	ACROBAT: 'acrobat',
	ACROBAT_STAGE: 'acrobat-stage',
	PRODUCT_INFORMATION: 'productInformation',
	SHARED_FOR_REVIEW: 'sharedForReview',
	NON_CC_APPS: 'nonCCApps',
	PROJECTX: 'projectx',
};
export const TOP_PS_QUERIES = [
	'photoshop',
	'photoshop faq',
	'photoshop download',
	'photoshop classic',
	'adobe photoshop',
	'download adobe photoshop',
	'download photoshop installer',
	'photoshop install',
	'photoshops',
	'photoshop application',
	'photoshop launcher',
	'photoshop update',
	'photoshop ap',
	'photoshop escritorio',
	'remove photoshop',
	'uninstall photoshop',
	'cancel photoshop',
	'deactivate photoshop',
	'latest version of photoshop',
	'update photoshop',
	'photoshop trial',
	'free photoshop',
	'photoshop 2019',
	'photography',
	'adobe photoshop cs6',
	'photoshop cc',
	'photoshop cc 2019',
	'photoshop cc 2018',
	'photoshop cc 2017',
	'photoshop cc 2015.5',
	'photoshop cc 2014',
	'photoshop cs6',
	'photoshop cs5',
	'photoshop cs4',
	'photoshop cs3',
	'photoshop cs2',
	'photoshop cs1',
	'photoshop cs 6',
	'photoshop cs 5',
	'photoshop cs 4',
	'photoshop cs 3',
	'photoshop cs 2',
	'photoshop cs 1',
	'photoshop cs',
	'photo editing',
	'photo compositing',
	'edit photo',
	'compositing',
	'psd',
	'psb',
	'ps',
	'ps6',
	'ps5',
	'photoshop twitter',
	'photoshop tutorials',
];
export const TOP_CC_QUERIES = [
	'creative cloud',
	'creative cloud faq',
	'creative cloud download',
	'creative',
	'cloud',
	'desktop',
	'adobe cc',
	'adobe cloud',
	'cc plans',
	'plans',
	'adobe creative',
	'creativecloud',
	'creative cloud manager',
	'cc',
	'cc faq',
	'cs',
	'crea',
	'creative cloude',
	'apps',
	'delete creative cloud',
	'download',
	'download cc',
	'download application manager',
	'download adobe creative cloud',
	'download adobe cc',
	'download creative',
	'download creative cloud installer',
	'creative cloud install',
	'creative clouds',
	'créative cloud',
	'creative cloud application',
	'creative cload',
	'creative clous',
	'crative cloud',
	'adobe installer',
	'app manager',
	'my plan',
	'my apps',
	'my account',
	'manage account',
	'manage my account',
	'manage my plan',
	'manage my apps',
	'adobe manager',
	'creatice cloud',
	'order history',
	'creative clowd',
	'cretive cloud',
	'adobe cc download',
	'desktop downloads',
	'desktop download',
	'creative cloud launcher',
	'criative cloud',
	'creative suite',
	'adobe creative suite',
	'crative',
	'creati',
	'adobe suite',
	'adobecc',
	'remove creative cloud',
	'creative cloud windows',
	'creative cloud update',
	'desktop apps',
	'creative cloud ap',
	'creative cloud escritorio',
	'cancel subscription',
	'cancel membership',
	'mes commandes',
	'pricing',
	'change plan',
	'cancel trial',
	'cancel free',
	'cancel plans',
	'want to cancel my account',
	'cancel account',
	'create cloud',
	'kreativ cloud',
	'creative clouf',
	'creative clou',
	'creativ cloud client',
	'ceative cloud',
	'cloud installer',
	'help installing',
	'help downloading',
	'uninstall the creative cloud desktop app',
	'cancel',
	'deactivate',
	'latest version of adobe',
	'update adobe cloud app',
	'install cc',
	'cc installer',
	'deactivate cc',
	'cancel cc',
	'cc free',
	'cc trial',
	'update cc',
	'uninstall cc',
	'remove cc',
	'cs5',
	'cs4',
	'cs3',
	'cs2',
	'cs1',
	'cs 5',
	'cs 4',
	'cs 3',
	'cs 2',
	'cs 1',
	'cs installer',
	'cs download',
	'cs update',
	'cs faq',
	'creative cloud twitter',
	'creative cloud tutorials',
	'adobe creative cloud',
];
export const SEARCH_NEW_FILTERS_LOCATION_OWNERSHIP_TYPE_MAP = {
	YourFiles: {
		ownershipType: {
			inclusions: ['owner', 'sharedByMe'],
		},
		type: {
			exclusions: ['Library', 'LibraryElement'],
		},
		container: {
			exclusions: ['Spaces'],
		},
	},
	SharedWithYou: {
		ownershipType: {
			inclusions: ['sharedWithMe'],
		},
	},
	TeamLibraries: {
		type: {
			inclusions: ['Library', 'LibraryElement'],
		},
		ownershipType: {
			inclusions: ['orgShared'],
		},
		container: {
			inclusions: ['Teams'],
		},
	},
	YourLibraries: {
		type: {
			inclusions: ['Library', 'LibraryElement'],
		},
		ownershipType: {
			inclusions: ['owner'],
		},
		container: {
			exclusions: ['Teams'],
		},
	},
	Spaces: {
		container: {
			inclusions: ['Spaces'],
		},
	},
	Lightroom: {
		scope: ['Lightroom'],
	},
};

export const UI_THEMES = {
	LIGHT: 'light',
	LIGHTEST: 'lightest',
	DARK: 'dark',
	DARKEST: 'darkest',
};

export const SEARCH_IN_APP_SOURCE_FOR_APP_LAUNCH_ANALYTICS = {
	APP_QUICK_LINK: 'AppQuickLink',
	APP_SHORTCUT: 'AppShorcut',
	SEARCH_RESULT: 'SearchResult',
	PRE_SEARCH_RECOMMENDATION: 'preSearchRecommendation',
};

export const DEEPLINK_ROUTES_PARAMS = {
	ALL_PLUGINS: {
		workflow: 'routeToPath',
		routePath: '/pmp/view/browse',
	},
	SEARCH_PLUGINS: {
		workflow: 'routeToPath',
		routePath: '/pmp/view/browse?search={searchTerm}',
		template: true,
	},
	PLUGIN_PDP: {
		workflow: 'routeToPath',
		routePath: '/pmp/view/pluginDetail/pluginId/{pluginId}',
		template: true,
	},
	ALL_FONTS: {
		workflow: 'routeToPath',
		routePath: '/fonts/added/all?familyName={familyName}',
		template: true,
	},
	ALL_FILES: {
		workflow: 'routeToPath',
		routePath: '/assets/files',
	},
};
export const SEARCH_CCD_CCH_SAMCAP_CGEN = {
	samcapId: 'samcap_id=ccdt_applist',
	ccdHost: 'CCDesktop',
	cchClient: 'CCHome',
	cchExpressCgenForSRP: 'promoid=TG8SLDYN&mv=other',
	cchExpressCgenForAppLink: 'promoid=TKZTL97M&mv=other',
	ccdExpressCgenForSRP: 'WPHDJ5X2',
	ccdExpressCgenForAppLink: 'WKRCJ9N3',
	ccdExpressCgenForSRPAXtemplates: 'trackingid=71KW6TBP',
	cchExpressCgenForSRPAXtemplates: 'promoid=6WTV6Y2Q&mv=other',
	cchExpressCgenForPreSearchAXtemplates: 'promoid=V2XYKRQM&mv=other',
	ccdExpressCgenForPreSearchAXtemplates: 'trackingid=V6NZKMZL',
	ccdExpressCgenForPreSearchAXtemplatesViewAll: 'VY36JWLD',
	cchExpressCgenForPreSearchAXtemplatesViewAll: 'VTC5K1BF',
	ccdExpressCgenForPreSearchQuickActions: 'trackingid=12B9DS9K&mv=in-product&mv2=accc',
	ccdExpressCgenForPreSearchQuickActionViewAll: 'trackingid=ZXL8DX1L&mv=in-product&mv2=accc',
	cchExpressCgenForPreSearchQuickActions: 'promoid=XKMMH8Z7&mv=other',
	cchExpressCgenForPreSearchQuickActionViewAll: 'promoid=XXTQGWS4&mv=other',
};

export const PRESEARCH_UI_SORT_ORDERS = {
	popularExpressTemplates: 1,
	appRecommendations: 0,
	popularExpressQuickActions: 2,
	quickLinks: 3,
};
export const SEARCH_CCD_COMPONENTS = {
	ccdPlugins: 'CCDPlugins',
};

export const SEARCH_QA_ICONS = {
	'convert-to-gif_dark': qa_gif_dark,
	'convert-to-mp4_dark': qa_mp4_dark,
	'image-resize_dark': qa_image_resize_dark,
	'merge-videos_dark': qa_merge_videos_dark,
	'remove-background_dark': qa_remove_background_dark,
	'resize-video_dark': qa_resize_video_dark,
	'trim-video_dark': qa_trim_video_dark,
};

export const SEARCH_GEN_AI_ICON = S2_Icon_AISparkles_20_N;

export const SourceOfQuery = {
	History: 'History',
	AutoComplete: 'AutoComplete',
	LeoRecommendation: 'Leo Recommended Summaries',
};

export const STORAGE_CONSTANTS = {
	unAuthKey: 'loggedOut',
};
